import * as swcHelpers from '@swc/helpers';
import { useEffect, useMemo } from 'react';
import { createCustomEvent } from './utils.js';

function handleTrackEvent(pageDetails) {
    return _handleTrackEvent.apply(this, arguments);
}
function _handleTrackEvent() {
    _handleTrackEvent = // Reusable function for handling event dispatch
    swcHelpers.asyncToGenerator(function*(pageDetails) {
        try {
            const details = yield pageDetails();
            if (details !== undefined) {
                dispatchTrackEvent(()=>Promise.resolve(details)
                );
            }
        } catch (error) {
            console.error('[Tealium] Error handling track event:', error);
        }
    });
    return _handleTrackEvent.apply(this, arguments);
}
// Hook for tracking events
function useTrackEvent(pageDetails) {
    useEffect(()=>{
        handleTrackEvent(pageDetails);
    }, [
        pageDetails
    ]);
}
// Hook for manually dispatching track events
function useDispatchTrackEvent() {
    const trackEventDispatcher = useMemo(()=>{
        return function() {
            var _ref = swcHelpers.asyncToGenerator(function*(pageDetails) {
                yield handleTrackEvent(pageDetails);
            });
            return function(pageDetails) {
                return _ref.apply(this, arguments);
            };
        }();
    }, []);
    return trackEventDispatcher;
}
// Dispatch function for individual track events
function dispatchTrackEvent(pageDetails) {
    return _dispatchTrackEvent.apply(this, arguments);
}
function _dispatchTrackEvent() {
    _dispatchTrackEvent = swcHelpers.asyncToGenerator(function*(pageDetails) {
        try {
            const details = yield pageDetails();
            if (details !== undefined) {
                const event = createCustomEvent(details);
                globalThis.dispatchEvent(event);
            }
        } catch (error) {
            console.error('[Tealium] Error dispatching track event:', error);
        }
    });
    return _dispatchTrackEvent.apply(this, arguments);
}

export { dispatchTrackEvent, useDispatchTrackEvent, useTrackEvent };
//# sourceMappingURL=use-track-event.js.map
